import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [wishlist, setWishlist] = useState([]);

  useEffect(() => {
    try {
      const c = JSON.parse(localStorage.getItem("poche_cart") || "[]");
      const w = JSON.parse(localStorage.getItem("poche_wishlist") || "[]");
      setItems(c);
      setWishlist(w);
    } catch {}
  }, []);

  const persist = (next, key = "poche_cart") => {
    localStorage.setItem(key, JSON.stringify(next));
  };

  const addToCart = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.product_id === product.product_id);
      let next;
      if (existing) {
        next = prev.map((i) => (i.product_id === product.product_id ? { ...i, qty: i.qty + qty } : i));
      } else {
        next = [
          ...prev,
          {
            product_id: product.product_id,
            name: product.name,
            subtitle: product.subtitle,
            price: product.price,
            image: product.images?.[0],
            qty,
          },
        ];
      }
      persist(next);
      return next;
    });
  };

  const removeFromCart = (product_id) => {
    setItems((prev) => {
      const next = prev.filter((i) => i.product_id !== product_id);
      persist(next);
      return next;
    });
  };

  const updateQty = (product_id, qty) => {
    setItems((prev) => {
      const next = prev.map((i) => (i.product_id === product_id ? { ...i, qty: Math.max(1, qty) } : i));
      persist(next);
      return next;
    });
  };

  const clearCart = () => {
    setItems([]);
    persist([]);
  };

  const toggleWishlist = (product) => {
    setWishlist((prev) => {
      const exists = prev.find((i) => i.product_id === product.product_id);
      let next;
      if (exists) next = prev.filter((i) => i.product_id !== product.product_id);
      else
        next = [
          ...prev,
          {
            product_id: product.product_id,
            name: product.name,
            subtitle: product.subtitle,
            price: product.price,
            image: product.images?.[0],
          },
        ];
      persist(next, "poche_wishlist");
      return next;
    });
  };

  const isWishlisted = (product_id) => wishlist.some((i) => i.product_id === product_id);

  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider
      value={{
        items,
        wishlist,
        addToCart,
        removeFromCart,
        updateQty,
        clearCart,
        toggleWishlist,
        isWishlisted,
        subtotal,
        count,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
